import React from "react";
import ModalShell from "./ModalShell";

const movementLabels = {
  initial_payment: "Pembayaran awal",
  payment: "Pembayaran",
  manual: "Manual",
  transfer: "Transfer",
  adjustment: "Penyesuaian opname",
  reversal: "Reversal",
  opening_balance: "Saldo awal",
};

const AccountDetailModal = ({ detail, loading, onClose, formatIDR, formatDateTime }) => {
  const account = detail?.account || {};
  const movements = detail?.movements?.data || [];
  return (
    <ModalShell eyebrow="AUDIT LEDGER" title={account.name || "Detail akun"} subtitle={`${account.code || "-"} · Setiap perubahan saldo tersimpan sebagai mutasi.`} onClose={onClose} size="xl">
      {loading && !detail ? <div className="cash-bank-loading"><span className="spinner-border text-primary" role="status" /><span>Memuat histori akun...</span></div> : <>
        <div className="cash-bank-detail-summary">
          <div><small>Saldo saat ini</small><strong>{formatIDR(account.current_balance)}</strong></div>
          <div><small>Kas masuk periode</small><strong className="text-success">+{formatIDR(detail?.summary?.period_in)}</strong></div>
          <div><small>Kas keluar periode</small><strong className="text-danger">-{formatIDR(detail?.summary?.period_out)}</strong></div>
          <div><small>Jumlah mutasi</small><strong>{detail?.summary?.movement_count || 0}</strong></div>
        </div>
        <div className="table-responsive cash-bank-ledger-table">
          <table className="table table-vcenter mb-0">
            <thead><tr><th>Waktu & sumber</th><th>Keterangan</th><th className="text-end">Sebelum</th><th className="text-end">Mutasi</th><th className="text-end">Sesudah</th><th>Pengguna</th></tr></thead>
            <tbody>
              {movements.length ? movements.map((movement) => <tr key={movement.id}>
                <td><strong>{formatDateTime(movement.occurred_at)}</strong><small className="d-block text-secondary">{movement.source_label} #{movement.source_id}</small></td>
                <td><span className="badge bg-secondary-lt mb-1">{movementLabels[movement.movement_type] || movement.movement_type}</span><div className="cash-bank-note">{movement.note || "-"}</div></td>
                <td className="text-end text-secondary">{formatIDR(movement.balance_before)}</td>
                <td className={`text-end fw-bold ${movement.direction === "in" ? "text-success" : "text-danger"}`}>{movement.direction === "in" ? "+" : "-"}{formatIDR(movement.amount)}</td>
                <td className="text-end fw-bold">{formatIDR(movement.balance_after)}</td>
                <td>{movement.created_by_name || "Sistem"}</td>
              </tr>) : <tr><td colSpan="6" className="text-center text-secondary py-5">Belum ada mutasi pada periode ini.</td></tr>}
            </tbody>
          </table>
        </div>
        {detail?.movements?.total > movements.length ? <div className="form-hint mt-3">Menampilkan {movements.length} dari {detail.movements.total} mutasi terbaru.</div> : null}
      </>}
    </ModalShell>
  );
};

export default AccountDetailModal;
